export const RenderSource = {
  CLIENT: 'client',
  SERVER: 'server',
} as const;

export type RenderSource = (typeof RenderSource)[keyof typeof RenderSource];
